import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { initMetaPixel, initEngagementTracking } from './utils/metaPixel';
function Root() {
  useEffect(() => {
    // Initialize Meta Pixel on mount
    initMetaPixel();
    // Initialize engagement tracking (scroll, time on page)
    initEngagementTracking();
  }, []);
  return <App data-id="element-342" />;
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-343">
    <Root data-id="element-344" />
  </React.StrictMode>);